import(/* webpackMode: "eager" */ "/mom-baby-web/src/app/(pages)/error.tsx");
